import React, { useEffect, useState } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCheck, faXmark } from "@fortawesome/free-solid-svg-icons";

/* 🔹 NESTED OBJECT MODAL (TABLE VIEW) */
const ObjectTableModal = ({ isOpen, data, title, onClose }) => {
    useEffect(() => {
        if (!isOpen) return;

        const handleEsc = (e) => {
            if (e.key === "Escape") onClose();
        };

        window.addEventListener("keydown", handleEsc);
        return () => window.removeEventListener("keydown", handleEsc);
    }, [isOpen, onClose]);

    if (!isOpen || !data) return null;

    return (
        <div className="fixed inset-0 bg-black/40 z-[999] flex items-center justify-center">
            <div className="bg-white rounded-lg w-[600px] max-h-[80vh] overflow-auto p-4">
                <div className="flex justify-between items-center mb-3">
                    <h3 className="font-semibold text-sm">{title}</h3>
                    <button
                        onClick={onClose}
                        className="text-red-500 text-lg leading-none"
                    >
                        ✕
                    </button>
                </div>

                <table className="w-full text-xs border">
                    <thead>
                        <tr className="bg-gray-100">
                            <th className="p-2 border text-left">Key</th>
                            <th className="p-2 border text-left">Value</th>
                        </tr>
                    </thead>
                    <tbody>
                        {Object.entries(data).map(([key, value]) => (
                            <tr key={key}>
                                <td className="p-2 border font-medium">{key}</td>
                                <td className="p-2 border break-all">
                                    {key === 'productImage' ? <img src={value} className="max-h-24 max-w-42" alt="" /> : typeof value === "object" && value !== null
                                        ? JSON.stringify(value, null, 2)
                                        : String(value)}
                                </td>
                            </tr>
                        ))}
                    </tbody>
                </table>
            </div>
        </div>
    );
};

const ReadOnlyTable = ({ headers, rows }) => {
    const [modalData, setModalData] = useState(null);
    const [modalTitle, setModalTitle] = useState("");

    const isObject = (val) =>
        val && typeof val === "object" && !Array.isArray(val);

    return (
        <div className="tableContainer max-w-[98%] relative">
            <table className="table text-xs w-[88vw]" role="table">
                <thead className="stickyHeader bg-[var(--mainCol)] text-white">
                    <tr>
                        {headers?.map((header) => (
                            <th key={header} className="p-1 text-left border">
                                {header.toUpperCase()}
                            </th>
                        ))}
                    </tr>
                </thead>

                <tbody>
                    {rows?.map((row) => (
                        <tr key={row.id}>
                            {headers.map((header) => (
                                <td key={header} className="p-3 border">
                                    {isObject(row[header]) ? (
                                        <button
                                            className="text-blue-600 underline text-xs"
                                            onClick={() => {
                                                setModalData(row[header]);
                                                setModalTitle(header);
                                            }}
                                        >
                                            View
                                        </button>
                                    ) : row[header] === true ? (
                                        <FontAwesomeIcon
                                            className="ml-2"
                                            color="var(--green_Main)"
                                            icon={faCheck}
                                        />
                                    ) : row[header] === false ? (
                                        <FontAwesomeIcon
                                            className="ml-2"
                                            color="indianred"
                                            icon={faXmark}
                                        />
                                    ) : row[header] === null || row[header] === "" ? (
                                        "-"
                                    ) : (
                                        String(row[header])
                                    )}
                                </td>
                            ))}
                        </tr>
                    ))}
                </tbody>
            </table>

            <ObjectTableModal
                isOpen={!!modalData}
                data={modalData}
                title={modalTitle}
                onClose={() => setModalData(null)}
            />
        </div>
    );
};

export default ReadOnlyTable;
